import { render } from "./mainIndex.vue?vue&type=template&id=a5ef4502&scoped=true"
import script from "./mainIndex.vue?vue&type=script&lang=js"
export * from "./mainIndex.vue?vue&type=script&lang=js"

import "./mainIndex.vue?vue&type=style&index=0&id=a5ef4502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ef4502"]])

export default __exports__